import React from "react";
import {
  setDataInLocalStorage,
  removeDataInLocalStorage,
} from "../utils/storage";

export type UserState = {
  name: string;
  pic: string;
  seenPersonalIntro: boolean;
};

type UserAction =
  | { type: "SET_DATA"; data: UserState }
  | { type: "SET_FIRST_NAME"; name: string }
  | { type: "SET_PIC"; data: string }
  | { type: "SET_SEEN_PERSONAL_INTRO" }
  | { type: "CLEAR_DATA" };

type UserContextType = {
  state: UserState;
  dispatch: React.Dispatch<UserAction>;
};

export const initialUserState: UserState = {
  name: "",
  pic: "",
  seenPersonalIntro: false,
};

const UserContext = React.createContext<UserContextType>({
  state: initialUserState,
  dispatch: () => {},
});

export default UserContext;

// User Reducer

export function userReducer(state: UserState, action: UserAction) {
  switch (action.type) {
    case "SET_FIRST_NAME": {
      console.log("SET_FIRST_NAME", action.name);
      return {
        ...state,
        name: action.name,
      };
    }
    case "SET_PIC": {
      console.log("SET_PIC");
      return {
        ...state,
        pic: action.data,
      };
    }
    case "SET_SEEN_PERSONAL_INTRO": {
      console.log("SET_SEEN_PERSONAL_INTRO");
      const newState = {
        ...state,
        seenPersonalIntro: true,
      };
      setDataInLocalStorage("user", newState);
      return newState;
    }
    case "SET_DATA": {
      console.log("SET_DATA", action.data);
      return {
        ...action.data,
      };
    }
    case "CLEAR_DATA": {
      console.log("CLEAR_DATA User");
      removeDataInLocalStorage("user");
      return initialUserState;
    }
    default:
      return state;
  }
}
